import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DirectivesModule } from '@common/directives/directives.module';
import { UIModule } from '@common/UI/UI.module';
import { CoreModule } from '@core/core.module';
import { ExportsComponent } from './exports/exports.component';
import { ImportsComponent } from './imports/imports.component';
import { ReturnsComponent } from './returns/returns.component';
import { LossesComponent } from './losses/losses.component';
import { VerificationComponent } from './verification/verification.component';
import { ViewerComponent } from './viewer/viewer.component';
import { NgxLoadingModule } from 'ngx-loading';
import { ConfirmerComponent as ImportConfirmer } from './imports/confirmer/confirmer.component';
import { ConfirmerComponent as ReturnConfirmer } from './returns/confirmer/confirmer.component';
import { FormsModule } from '@angular/forms';
import { UiComponent } from './ui/ui.component';



@NgModule({
  declarations: [
    ImportsComponent,
    ExportsComponent,
    ReturnsComponent,
    LossesComponent,
    VerificationComponent,
    ViewerComponent,
    ImportConfirmer,
    ReturnConfirmer,
    UiComponent
  ],
  imports: [
    CommonModule,

    CoreModule,
    DirectivesModule,
    UIModule,
    NgxLoadingModule,
    FormsModule
  ],

  exports: [
    UiComponent
  ]
})
export class InvoicesModule { }
